import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(() => ({
  poolImg: {
    width: 30,
    height: 30,
    objectFit: 'cover',
    borderRadius: '50%',
  },

  iconButton: {
    width: 36,
    padding: 0,
    minWidth: 0,

    '& svg': {
      width: 16,
      height: 16,
    },
  },
}));
